export default "__VITE_ASSET__DQgANq2k__"